// extracted by mini-css-extract-plugin
module.exports = {"checkoutButtons":"wySzUA"};